export const getLinkStatus = value => {
  const raw = String(value || '').trim();
  if (!raw) {return { available: true, label: '' };}

  const url = raw.toLowerCase();

  const shutDownValues = new Set([
    'closed',
    'shutdown',
    'shut down',
    'shut-down',
    'offline',
    'private',
  ]);
  if (shutDownValues.has(url)) {return { available: false, label: 'Shut down' };}

  const notAvailableValues = new Set([
    'not available',
    'notavailable',
    'unavailable',
    'n/a',
    'na',
    'none',
  ]);
  if (notAvailableValues.has(url)) {return { available: false, label: 'Not available' };}

  return { available: true, label: '' };
};

export const normalizeUrl = value => {
  const url = String(value || '').trim();
  if (!url) {return '';}
  const status = getLinkStatus(url);
  if (!status.available) {
    return '';
  }
  if (url.startsWith('http://') || url.startsWith('https://')) {return url;}
  if (url.startsWith('//')) {return `https:${url}`;}
  // Handle common Contentful data omissions like "example.com/path"
  if (/^[\w-]+\.[\w.-]+(\/|$)/.test(url)) {return `https://${url}`;}
  return url;
};

export const isClosedLink = value => {
  const status = getLinkStatus(value);
  return !status.available;
};
